import { coverLetterDataSchema, defaultCoverLetterData, idSchema } from "@resume-studio/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { userSchema } from "../user";

export const coverLetterSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: coverLetterDataSchema.default(defaultCoverLetterData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  userId: idSchema,
  type: z.enum(["resume", "cover"]).default("cover"),
  user: userSchema.optional(),
  createdAt: z.date().or(z.dateString()),
  updatedAt: z.date().or(z.dateString()),
});

export class CoverLetterDto extends createZodDto(coverLetterSchema) {}
